import { render, staticRenderFns } from "./BreadCrumbs.vue?vue&type=template&id=6cb08393&scoped=true&"
import script from "./BreadCrumbs.vue?vue&type=script&lang=js&"
export * from "./BreadCrumbs.vue?vue&type=script&lang=js&"
import style0 from "./BreadCrumbs.vue?vue&type=style&index=0&id=6cb08393&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cb08393",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/uat.mediaworkflow.winnipeg.ca/laravel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6cb08393')) {
      api.createRecord('6cb08393', component.options)
    } else {
      api.reload('6cb08393', component.options)
    }
    module.hot.accept("./BreadCrumbs.vue?vue&type=template&id=6cb08393&scoped=true&", function () {
      api.rerender('6cb08393', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/csmworkflow/js/components/deliverables/BreadCrumbs.vue"
export default component.exports